

export enum InfoClientSidebar {
  GENERAL = 'General',
  CONTACTS = 'Contacte',
  MODULES = 'Module',
  OPERATORS = 'Operatori',
  PERMISSIONS = 'Permisiuni'
}
